module.exports = "/_next/static/videos/aboutCompanyMobileVideo-9dc45a94ffb6dc44006cbe9e5c01b0b0.mp4";